import React from 'react'
import cardelizabeth from "../assets/images/cardelizabeth.svg"
const DeskofElizabeth = () => {
  return (
    <>
         <div className="relative">
          <svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 1440 1892"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              d="M0 42.35C575.38 -12.7346 891.319 -15.482 1440 42.35V1892C877.655 1798.63 562.346 1798.7 0 1892V42.35Z"
              fill="#EFF6FF"
            />
          </svg>
          <div className="md:mt-0 mt-10 second-bg-from-gray-skew">
            <div className="main-container mx-auto text-center mx-6">
              <div
                className="flex justify-center items-center rounded-[8px]"
                style={{
                  backgroundImage: "url('https://cdn.blackincae.com/IhJ-paper-background.jpg')",
                  backgroundRepeat: "repeat",
                  boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)",
                }}
              >
                <div className="flex justify-center items-center">
                  <div className="flex justify-center items-center pt-6">
                    <div className="max-w-4xl w-full md:px-8 px-5 text-start">
                      <div className="">
                        <p className="mb-8 text-[#233751] font-bold text-[24px] italic bold-font">
                          <span className="border-b-4 border-[#233751] pb-1 inline-block bold-font">
                            From The D
                          </span>
                          esk of Dr. Ali 
                        </p>
                        <p className="mb-8 text-[#233751] text-center font-bold text-[20px] mx-auto max-w-lg px-2 bold-font">
                          Right now, for just a moment, I want you to imagine
                          how good you’ll feel in just 30 days.
                        </p>
                        <div className="flex flex-col md:flex-row">
                          <div className="md:w-2/3 md:pr-4 pr-0 text-[20px] font-normal">
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              See yourself waking up rested and refreshed every
                              single day.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              Your lungs are clear and your energy levels are
                              through the roof.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              Your skin looks and feels more vibrant and alive. 
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              You feel stronger, younger, and more capable -
                              your joints are pain-free.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              Your immune system is stronger than ever, so
                              you’re ready to take on life without fear of
                              getting sick.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              You’re feeling invincible — full of energy,
                              confidence, and vitality!
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              If you want that to become your reality in just a
                              few day’s time… 
                            </p>
                          </div>
{/* a  */}
                          <div className="md:w-1/2 flex flex-col items-center hidden md:block">
                            <div className="mb-4">
                              <img
                                src="https://cdn.blackincae.com/ayn-men-women-l.png"
                                alt="Lung Immune Product"
                                className="w-[315px] rounded-lg"
                              />
                            </div>
                          </div>

                          <div className="md:w-1/2 flex flex-col items-center block md:hidden">
                            <div className="mb-4">
                              <img
                                src="https://cdn.blackincae.com/fs9-image-3-.png"
                                alt="Lung Immune Product"
                                className="w-[315px] rounded-lg"
                              />
                            </div>
                          </div>
                        </div>

                        <p className="mb-4 text-[#233751] text-center font-bold text-[26px] mx-auto max-w-md bold-font italic">
                          Here’s what to do next.
                        </p>
                        <div className="mb-4 text-[#233751] text-center font-bold text-[26px] mx-auto bold-font">
                          <div className="text-[26px] leading-[28px]">
                            Simply
                            <span className="gift-highlight-click-bg-yellow text-[#233751]">
                              click the button below
                            </span>
                            now to claim your FREE Vitality Box.
                          </div>
                        </div>

                        <p className="mb-10 text-[#233751] text-center font-normal text-[20px] mx-auto px-10 hidden md:block">
                          All you have to do is cover the $29.95 shipping. 
                          <br />
                          That’s it. 
                        </p>

                        <p className="mb-10 text-[#233751] text-center font-normal text-[20px] mx-auto px-10 block md:hidden">
                          All you have to do is cover the $29.95 shipping. 
                          <br />
                          <br />
                          That’s it. 
                        </p>

                        <div className="flex flex-col md:flex-row gap-8">
                          <div className="md:w-1/3 flex flex-col items-center hidden md:block">
                            <div className="mb-4">
                              <img
                                src="https://cdn.blackincae.com/zQr-men-l.png"
                                alt="Lung Immune Product"
                                className="w-[255px] rounded-lg"
                              />
                            </div>
                          </div>
                          <div className="md:w-1/3 flex flex-col items-center block md:hidden">
                            <div className="mb-4">
                              <img
                                src="https://cdn.blackincae.com/zoj-image-1.png"
                                alt="Lung Immune Product"
                                className="w-[255px] rounded-lg"
                              />
                            </div>
                          </div>

                          <div className="md:w-2/3 text-[20px] font-normal md:pr-6 pr-0">
                            <p className="mb-4 text-[#000000] leading-[24px] font-bold bold-font">
                              In just a few short days, you’ll be on your way to
                              a healthier, stronger, more vibrant version of
                              yourself.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              Before I decided to offer this Vitality Box
                              online, I field-tested it with my patients here in
                              Atlanta.
                            </p>

                            <p className="mb-4 text-[#000000] leading-[24px]">
                              All I heard was how much more vibrant and
                              energetic they felt.
                            </p>

                            <p className="mb-4 text-[#000000] leading-[24px]">
                              That’s why, as a doctor, I urge you to say{" "}
                              <span className="bold-font"> “YES” </span> to The
                              Vitality Box today.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              You will not have another chance to come back to
                              this page. 
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              So click the button below right now to claim your
                              one-time chance at this
                              <span className="bold-font">
                                {" "}
                                $500 VIP Gift.{" "}
                              </span>
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              <span className="bold-font">
                                Your complete and total satisfaction is
                                guaranteed for 3 months!
                              </span>
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              Which means I’m shouldering all the risk for your
                              peace of mind.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              There’s no reason not to claim your Vitality Box
                              today.
                            </p>
                            <p className="mb-4 text-[#000000] leading-[24px]">
                              It’s not only
                              <span className="bold-font"> FREE </span> today
                              but
                              <span className="bold-font"> RISK-FREE </span> as
                              well.
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-4 pt-4 pb-8 md:justify-end justify-start">
                          <img
                            className="w-20 h-20 rounded-full"
                            src="https://cdn.blackincae.com/3Lr-ali-square-1-1-.png"
                            alt=""
                          />
                          <div className="text-[20px] font-normal text-[#000000] leading-[24px]">
                            <div>All the best,</div>
                            <div className="text-[20px] font-normal text-[#000000]">
                              Dr. Ali
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default DeskofElizabeth